<template>
  <!-- floating status picker (ops_vsm's vb-picker-pop): rendered once at the
       page root, position: fixed via styleObj so it escapes the table's
       scrollport. the vsm_ops_table mixin owns anchoring and dismissal. -->
  <div
    class="vst-picker-pop"
    :style="styleObj"
    role="menu"
    :aria-label="ariaLabel"
    @keydown.esc="$emit('esc')"
  >
    <button
      v-for="opt in options"
      :key="opt.value"
      type="button"
      class="vst-status-opt"
      :class="{ 'vst-status-opt--current': current === opt.value }"
      role="menuitemradio"
      :aria-checked="current === opt.value ? 'true' : 'false'"
      @click="$emit('select', opt.value)"
    ><span class="vst-status-chip" :class="chipClass(opt.value)">{{ opt.text }}</span><i v-if="current === opt.value" class="fa fa-check vst-status-opt-check" aria-hidden="true"></i></button>
  </div>
</template>

<script>
export default {
  name: 'VsmStatusPickerPop',
  props: {
    options: { type: Array, default: () => [] },
    current: { type: String, default: null },
    chipClass: { type: Function, required: true },
    styleObj: { type: Object, default: null },
    ariaLabel: { type: String, default: 'Set status' },
  },
}
</script>
